/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDeploymentsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListDeploymentsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListDeploymentsSecurity = {
  option1?: ListDeploymentsSecurityOption1 | undefined;
  option2?: ListDeploymentsSecurityOption2 | undefined;
};

export type ListDeploymentsRequest = {
  /**
   * The cursor to fetch results from
   */
  cursor?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDeploymentsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListDeploymentsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListDeploymentsSecurityOption1$Outbound,
  ListDeploymentsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listDeploymentsSecurityOption1ToJSON(
  listDeploymentsSecurityOption1: ListDeploymentsSecurityOption1,
): string {
  return JSON.stringify(
    ListDeploymentsSecurityOption1$outboundSchema.parse(
      listDeploymentsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListDeploymentsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListDeploymentsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListDeploymentsSecurityOption2$Outbound,
  ListDeploymentsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDeploymentsSecurityOption2ToJSON(
  listDeploymentsSecurityOption2: ListDeploymentsSecurityOption2,
): string {
  return JSON.stringify(
    ListDeploymentsSecurityOption2$outboundSchema.parse(
      listDeploymentsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListDeploymentsSecurity$Outbound = {
  Option1?: ListDeploymentsSecurityOption1$Outbound | undefined;
  Option2?: ListDeploymentsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListDeploymentsSecurity$outboundSchema: z.ZodMiniType<
  ListDeploymentsSecurity$Outbound,
  ListDeploymentsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListDeploymentsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListDeploymentsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listDeploymentsSecurityToJSON(
  listDeploymentsSecurity: ListDeploymentsSecurity,
): string {
  return JSON.stringify(
    ListDeploymentsSecurity$outboundSchema.parse(listDeploymentsSecurity),
  );
}

/** @internal */
export type ListDeploymentsRequest$Outbound = {
  cursor?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDeploymentsRequest$outboundSchema: z.ZodMiniType<
  ListDeploymentsRequest$Outbound,
  ListDeploymentsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDeploymentsRequestToJSON(
  listDeploymentsRequest: ListDeploymentsRequest,
): string {
  return JSON.stringify(
    ListDeploymentsRequest$outboundSchema.parse(listDeploymentsRequest),
  );
}
